"use client";

import { useRouter } from "next/navigation";
import { fetchWithAuth } from "@/lib/firebase/authInterceptor";
import BaseModal from "./BaseModal";

export default function MemeDeleteModal({ memeId }: { memeId: string }) {
  const router = useRouter();

  const deleteMeme = async () => {
    const response = await fetchWithAuth(`/api/v2/meme/${memeId}`, {
      method: "DELETE"
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to delete meme");
    }
    router.push("/work");
  };

  return (
    <BaseModal
      title="Delete Meme"
      content="Are you sure you want to delete this meme? Once deleted, you cannot access it in your history."
      confirmText="Delete"
      onConfirm={deleteMeme}
    />
  );
}
